import { noop } from 'lodash'
import { createStore } from 'zustand'

import { GenericalRecord } from '@eastcoal/common/types/utilities'
import { promiseNoop } from '@eastcoal/common/utils/promise'

import { FormMode } from '../../enums/FormMode'
import { SubmitType } from '../../enums/SubmitType'
import { resolvePattern } from '../utils/resolvePattern'

import { CrudFormOptions, CrudFormStore } from './interface'

export const createCrudFormStore = <
  FormData extends GenericalRecord,
  DetailData extends GenericalRecord,
  Context
>({
  form,
  mode: defaultMode,
  detailType
}: CrudFormOptions<FormData, DetailData, Context>) =>
  createStore<CrudFormStore<FormData, DetailData, Context>>((set, get) => ({
    form,
    context: undefined,
    mode: defaultMode,
    onModeChange: noop,
    setMode(value) {
      const { mode, onModeChange, form, detailData, setDeatilData } = get()
      // 无需重复设置
      if (mode === value) return
      // 重置 error
      set({ mode: value, readError: undefined, submitError: undefined })
      form.setPattern(resolvePattern(value))
      // 重置表单数据
      if (value === FormMode.CREATE) {
        form.reset()
        // 回滚到创建之前的状态
      } else if (value === FormMode.READ) {
        setDeatilData(detailData)
      }
      onModeChange?.(value)
    },

    hasKeeponBtn: false,
    registerKeeponButton() {
      set({ hasKeeponBtn: true })
      return () => set({ hasKeeponBtn: false })
    },

    readError: undefined,
    readLoading: false,
    detailType: detailType ?? 'values',
    detailData: Object.create(null),
    reloadDetail: noop,
    setDeatilData(values) {
      const { form, detailType } = get()
      form[detailType === 'initialValues' ? 'setInitialValues' : 'setValues'](
        values
      )
      set({ detailData: values })
    },

    onSuccess: undefined,
    formData: Object.create(null),
    submitError: undefined,
    resetSubmitError() {
      set({ submitError: undefined })
    },
    submitLoading: false,
    submitRequest: promiseNoop,
    submit(context) {
      const { form, detailData, onSuccess, submitRequest, setDeatilData } =
        get()
      return form.submit(async values => {
        const formData = await submitRequest(values, context)
        const newDetailData = {
          ...detailData,
          ...values,
          ...formData
        }
        onSuccess?.(newDetailData, context ?? {})
        if (!(context?.submitType === SubmitType.SUBMIT && context.keepon)) {
          // 保存或者提交后应更新detail
          setDeatilData(newDetailData)
        }
        return newDetailData
      })
    }
  }))
